module.exports = __webpack_public_path__ + "img/vertical_3_2_0.3f01436f.png";